import { Link } from "react-router-dom";

const links = [
  { label: "Help Guide", to: "/help" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms-of-service" },
  { label: "Refund Policy", to: "/refund-policy" },
  { label: "Data Deletion", to: "/data-deletion" },
];

export default function DashboardFooter() {
  return (
    <footer className="border-t border-ink/10 mt-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-6 text-xs text-ink/40 md:flex-row md:items-center md:justify-between md:px-10">
        <p>© {new Date().getFullYear()} Checkout DM</p>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-ink/70">
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
